"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _UIIconButton = _interopRequireDefault(require("./UIIconButton"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var EXCLUDED_ICON_BUTTON_PROP_NAMES = ['children', 'use', 'truncate', 'truncateStringProps'];
var ICON_NAMES = {
  first: 'first',
  previous: 'left',
  next: 'right',
  last: 'last'
};

var _default = _react.default.createClass({
  displayName: "UIStepperButton",
  propTypes: (0, _extends2.default)({}, (0, _omit.default)(_UIIconButton.default.propTypes, EXCLUDED_ICON_BUTTON_PROP_NAMES), {
    'aria-label': _react.PropTypes.string.isRequired,
    iconName: _react.PropTypes.oneOf(Object.keys(ICON_NAMES)).isRequired
  }),
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, (0, _omit.default)(_UIIconButton.default.defaultProps, EXCLUDED_ICON_BUTTON_PROP_NAMES));
  },
  render: function render() {
    var _this$props = this.props,
        iconName = _this$props.iconName,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["iconName"]);
    return _react.default.createElement(_UIIconButton.default, (0, _extends2.default)({}, rest, {
      use: "tertiary-light"
    }), _react.default.createElement(_UIIcon.default, {
      name: ICON_NAMES[iconName]
    }));
  }
});

exports.default = _default;
module.exports = exports.default;